import { Bell } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { api } from "@/api";
import { timeAgo } from "@/components/projects/common";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function NotificationBell() {
  const navigate = useNavigate();
  const [data, setData] = useState({ items: [], unread: 0 });
  const load = useCallback(() => api.get("/notifications").then(({ data: d }) => setData(d)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  const open = async (n) => { await api.post("/notifications/read", { id: n.id }).catch(() => {}); load(); navigate(n.link); };
  const readAll = async () => { await api.post("/notifications/read", {}).catch(() => {}); load(); };
  return (
    <Popover onOpenChange={(o) => o && load()}>
      <PopoverTrigger asChild>
        <button type="button" className="pj-bell" title="Notifications" data-testid="notifications-bell"><Bell size={17} /><span>Notifications</span>{data.unread > 0 && <span className="nav-badge" data-testid="notifications-badge">{data.unread}</span>}</button>
      </PopoverTrigger>
      <PopoverContent className="pj-notif-pop" align="end" side="bottom" data-testid="notifications-panel">
        <header><strong>Notifications</strong>{data.unread > 0 && <button type="button" className="link-button" onClick={readAll} data-testid="notifications-read-all">Tout marquer comme lu</button>}</header>
        {data.items.length === 0 && <p className="pj-empty">Rien de nouveau.</p>}
        <ul>{data.items.map((n) => <li key={n.id}><button type="button" className={n.read ? "" : "is-unread"} onClick={() => open(n)} data-testid={`notification-${n.id}`}><span>{n.text}</span><small>{n.project_name} · {timeAgo(n.created_at)}</small></button></li>)}</ul>
      </PopoverContent>
    </Popover>
  );
}
